export default {
  SET_MARK_AS_PAID_MODAL: (state, val) => { state.isShown = val; },
  SET_INVOICE_AMOUNT: (state, val) => { state.formData.amount = val; },
  SET_INVOICE_ID: (state, val) => { state.invoiceId = val; },
  SET_ERRORS: (state, val) => { state.errors = val; },
  CLEAR_ERRORS: (state, key) => { state.errors[key] = []; },
  SET_SAVING: (state, val) => { state.saving = val; },
  SET_SUCCESS: (state, val) => { state.success = val; },
};
